import { render } from "./MainData.vue?vue&type=template&id=32a22b3e"
import script from "./MainData.vue?vue&type=script&lang=js"
export * from "./MainData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__